import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import Vue from 'vue';
import QSpinner from "../spinner/QSpinner.js";
import TransitionMixin from "../../mixins/transition.js";
import DarkMixin from "../../mixins/dark.js";
import ListenersMixin from "../../mixins/listeners.js";
export default Vue.extend({
  name: 'QInnerLoading',
  mixins: [ListenersMixin, DarkMixin, TransitionMixin],
  props: {
    showing: Boolean,
    color: String,
    size: {
      type: [String, Number],
      default: 42
    },
    label: String,
    labelClass: String,
    labelStyle: [String, Array, Object]
  },
  computed: {
    classes: function classes() {
      return 'q-inner-loading absolute-full column flex-center' + (this.isDark === true ? ' q-inner-loading--dark' : '');
    },
    labelClasses: function labelClasses() {
      return 'q-inner-loading__label' + (this.labelClass !== void 0 ? " ".concat(this.labelClass) : '');
    }
  },
  methods: {
    __getInner: function __getInner(h) {
      var child = [h(QSpinner, {
        props: {
          size: this.size,
          color: this.color
        }
      })];

      if (this.label !== void 0) {
        child.push(h('div', {
          class: this.labelClasses,
          style: this.labelStyle
        }, [this.label]));
      }

      return child;
    },
    __getContent: function __getContent(h) {
      return this.showing === true ? [h('div', {
        staticClass: this.classes,
        on: _objectSpread({}, this.qListeners)
      }, this.$scopedSlots.default !== void 0 ? this.$scopedSlots.default() : this.__getInner(h))] : void 0;
    }
  },
  render: function render(h) {
    return h('transition', {
      props: {
        name: this.transition,
        appear: true
      }
    }, this.__getContent(h));
  }
});